import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';
import LocalStorage from '../../utils/localStorage';

class orderStore {

    // Properties

    @observable orders = [];
    @observable requestOrders = [];
    @observable inProgressOrders = [];
    @observable reservedOrders = [];
    @observable scheduleOrders = [];
    @observable totalPrice = 0;
    @observable totalOrder = 0;

    @observable addOrderLoading = false;
    @observable showOrderDetailModal = false;
    @observable orderDetail = null;

    @observable todayOrders = [];

    @action getTodayOrders() {
        const tenantId = LocalStorage.Get('companyId');
        const roomNumber = LocalStorage.Get('roomNo');
        const guestId = LocalStorage.Get('customerId');
        let langName = window.localStorage.getItem('lang') || 'en';

        return ApiCaller.Order.apiGetTodayOrders(tenantId, roomNumber, guestId, langName).then((todayOrderResponses) => {
            if (todayOrderResponses) {
                if (todayOrderResponses.result) {
                    if (todayOrderResponses.result.length > 0) {
                        this.todayOrders = todayOrderResponses.result;

                        return this.todayOrders;
                    }
                }
            }
        });
    }
}

export default new orderStore()